import React, { useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';

const TermsPage = () => {
  useEffect(() => {
    document.title = 'Terms of Service | Nexus LBE';
  }, []);

  return (
    <div className="relative">
      {/* Hero */}
      <section className="relative overflow-hidden pt-20 pb-12 lg:pt-28 lg:pb-16 gradient-sunset">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl text-center">
          <Badge variant="outline" className="mb-4">Legal</Badge>
          <h1 className="font-['Geist'] tracking-tight text-4xl sm:text-5xl mb-4">
            Terms of Service
          </h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-10 lg:py-14">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <Card>
            <CardContent className="p-8 md:p-12 prose prose-sm max-w-none">
              <div className="space-y-8 text-muted-foreground">
                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Agreement to Terms</h2>
                  <p className="leading-relaxed">
                    By accessing and using the Nexus LBE website, you accept and agree to be bound by the terms and 
                    provisions of this agreement. If you do not agree to these terms, please do not use this website.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Use of Website</h2>
                  <p className="leading-relaxed mb-3">
                    This website is provided for informational purposes about Nexus LBE's services and partnership opportunities. 
                    You agree to:
                  </p>
                  <ul className="list-disc pl-6 space-y-1">
                    <li>Use the website only for lawful purposes</li>
                    <li>Not attempt to gain unauthorized access to any systems or networks</li>
                    <li>Not transmit any harmful code or malicious software</li>
                    <li>Not collect or harvest information from the website</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Intellectual Property</h2>
                  <p className="leading-relaxed">
                    All content on this website, including text, graphics, logos, images, and software, is the property of 
                    Nexus LBE or its content suppliers and is protected by international copyright laws. You may not reproduce, 
                    distribute, or create derivative works without explicit written permission.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Contact Form Submissions</h2>
                  <p className="leading-relaxed">
                    By submitting information through our contact forms, you consent to us using that information to respond to 
                    your inquiry and for related business purposes. We will handle your information in accordance with our Privacy Policy.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Disclaimer of Warranties</h2>
                  <p className="leading-relaxed">
                    This website is provided "as is" without any representations or warranties. Nexus LBE makes no warranties 
                    regarding the accuracy, reliability, or completeness of the content provided.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Limitation of Liability</h2>
                  <p className="leading-relaxed">
                    Nexus LBE shall not be liable for any direct, indirect, incidental, consequential, or punitive damages 
                    arising from your use of this website or inability to use the website.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">External Links</h2>
                  <p className="leading-relaxed">
                    This website may contain links to external sites. Nexus LBE is not responsible for the content or privacy 
                    practices of external websites.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Changes to Terms</h2>
                  <p className="leading-relaxed">
                    We reserve the right to modify these terms at any time. Your continued use of the website following any 
                    changes constitutes acceptance of those changes.
                  </p>
                </div>

                <div>
                  <h2 className="font-['Geist'] text-2xl text-foreground mb-3">Contact Information</h2>
                  <p className="leading-relaxed">
                    If you have questions about these Terms of Service, please contact us at:
                    <br />
                    <a href="mailto:hello@nexuslbe.com" className="text-primary hover:text-[hsl(17_62%_34%)] font-medium">
                      hello@nexuslbe.com
                    </a>
                  </p>
                </div>

                <div className="pt-4 border-t border-border">
                  <p className="text-xs">
                    This is a placeholder terms of service document. Nexus LBE will provide comprehensive terms of service 
                    reviewed by legal counsel before launching commercial operations.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
